
import { synczbase } from '../../lib/synczbase';

export const uploadDeliveryFile = async (file: File, path?: string): Promise<string> => {
  const uploaded = await synczbase.uploadFile(file);
  return uploaded.url;
};

export const deleteFile = async (url: string) => {
    if (!url) return;
    try {
        const parts = url.split('/');
        const fileId = parts[parts.length - 1]?.split('?')[0];
        if (fileId) {
            await synczbase.deleteStorageFile(fileId);
        }
    } catch (error: any) {
        console.error("Error deleting file:", error);
    }
};

export const listAppFiles = async (appId?: string) => {
    return await synczbase.listStorageFiles(appId);
};

